export const setToken = (token: string) => {
    window.sessionStorage.setItem('token', token);
};

export const getToken = () => {
    const token = window.sessionStorage.getItem('token');
    return token;
};